import React, { useEffect  , useState} from 'react';
import { useParams } from 'react-router-dom';

//*MUI
import { Box, Checkbox, Divider } from '@mui/material';

//*files
import cssClasses from './Cp.module.css';
import ThreeDotsMenu from '../../../Subcomponents/ThreeDotsMenu';
import Datagrid from '../../../Subcomponents/Datagrid';

//*Redux
import { useDispatch , useSelector} from 'react-redux';
import action from '../../../Redux Store/actions';
import Button from '../../../Subcomponents/Button';
import {
  CpRelationsData,
  DeleteSelectedCps,
  getAllCp,
  getAllCpByProject,
  getAllCpForPagination, getAllCpForSustenance, getAllUsers, getAllUsersForSustenance, getProjectByProjectName, SalesRelationsData, SaveSelectedCp, SaveSelectedUsers,
} from '../../../Services/SustenanceService';

import { errorTost, successTost } from '../../../Services/Toast';
import { cloneDeep, differenceWith, isEqual, sortBy, uniqBy } from 'lodash';
import SelectSalesCp from '../../SelectSalesCp/SelectSalesCp';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import { getAllCpByLaunch } from '../../../Services/Launch';

function CpSales() {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const [allCp, setAllCp] = useState([])
  const [allChildCp, setAllChildCp] = useState([])
  const [searchCp, setSearchCp] = useState('')


  useEffect(() => {
      dispatch(action.activeMenu('sales'));
      getProjectData();
    }, []);

    function getProjectData() {
      getProjectByProjectName(projectId).then((resp) => {
        console.log("Projects-Data", resp.data[0].projectName)
        setProjectName(resp.data[0])
      })
    }
  
    useEffect(() => {
          if (allCp.length === 0) {
              presentLoader()
              getAllCpForSustenance().then((resp) => {
                console.log("resp" , resp)
                  resp.data.forEach((ele, index) => { ele.id = ele.cpId; ele.show = true; ele.index = index;
                     ele.contactPersonName = ele.CpContactPerson[0].name; ele.email = ele.CpContactPerson[0].email; ele.contactNumber = ele.CpContactPerson[0].contactNumber; ele.isSelected = false })
                     getAllCpByProject(projectId).then((res) => {
                      if (res.data.length > 0) {
                        //   res.data.forEach((ele, index) => {
                        //       resp.data[resp.data.findIndex((e) => e.cpId === ele.cpId)].isSelected = true
                        //       resp.data = sortBy(resp.data, [function (o) { return !o.isSelected; }])
                        //       let newarr = cloneDeep(resp.data)
                        //       if (index === res.data.length - 1) {
                        //           // setAllExistingCp(resp.data.filter((e) => { return e.isSelected === true }))
                        //           setAllChildCp([...resp.data])console.log("allCp", allCp);
                        //           setAllCp([...newarr])
                        //           dismissLoader()
                        //       }
                        //   })
                            res.data.forEach((ele, index) => {
                                const foundIndex = resp.data.findIndex((e) => e.cpId === ele.cpId);
                                if (foundIndex !== -1) {
                                    resp.data[foundIndex].isSelected = true;
                                }
                            });
                            resp.data = sortBy(resp.data, [function (o) { return !o.isSelected; }]);
                            let newarr = cloneDeep(resp.data);
                            setAllChildCp([...resp.data]);
                            setAllCp([...newarr]);
                            dismissLoader();
                      } else {
                          let newarr = cloneDeep(resp.data)
                          setAllChildCp([...resp.data])
                          setAllCp([...newarr])
                          dismissLoader()
                      }
                  }).catch((err) => {
                      let newarr = cloneDeep(resp.data); setAllChildCp([...resp.data]); setAllCp([...newarr])
                      dismissLoader()
                  })
              }).catch((err) => {
                  dismissLoader()
              })
          } else {
              if (searchCp === '') {
                  allChildCp.forEach((e, index) => { setAllChildCp((pre) => { pre[index].show = true; return [...pre] }) })
                  allCp.forEach((e, index) => { setAllCp((pre) => { pre[index].show = true; return [...pre] }) })
              } else {
                  allCp.forEach((ele) => {
                      if (!ele.billingName.includes(searchCp.toUpperCase())) {
                          setAllChildCp((pre) => { pre[pre.findIndex((e) => e.billingName === ele.billingName)].show = false; return [...pre] })
                          setAllCp((pre) => { pre[pre.findIndex((e) => e.billingName === ele.billingName)].show = false; return [...pre] })
                      } else {
                          setAllChildCp((pre) => { pre[pre.findIndex((e) => e.billingName === ele.billingName)].show = true; return [...pre] })
                          setAllCp((pre) => { pre[pre.findIndex((e) => e.billingName === ele.billingName)].show = true; return [...pre] })
                      }
                  })
                  setAllChildCp(sortBy(allChildCp, [function (o) { return !o.isSelected }]))
              }
          }
      
  }, [searchCp])

const [projectName,setProjectName] = useState("");

const cpGridColumns = [
  {
      field: "billingName",
      headerName: "Cp Name",
      width: 400,
      renderCell: (params) => {
          return (
              <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem'
              }}>
                  <div>
                      <Checkbox checked={params.row?.isSelected} onChange={(e) => { setAllChildCp((pre) => { pre[pre.findIndex((e) => e.id === params.row.id)].isSelected = !pre[pre.findIndex((e) => e.id === params.row.id)].isSelected; return [...pre] }) }} />
                  </div>
                  <div>
                      <p>{params.row.billingName}</p>
                  </div>
              </div>
          )
      }
  },
  {
      field: "contactPersonName",
      headerName: "Contact Person Name",
      width: 300
  },
  {
      field: "email",
      headerName: "Mail Id",
      width: 290
  },
  {
      field: "contactNumber",
      headerName: "Contact Number",
      width: 250
  },
]


  useEffect(() => {
    dispatch(action.activeMenu('cp'));
    getProjectData();
  }, []);


function SaveCp() {
 
    let allExistingCp = allCp.filter((e) => { return e.isSelected === true })
    let arr = allChildCp.filter((e) => { return e.isSelected === true })
    if (arr.length === 0) {
        let newarr = cloneDeep(allCp)
        setAllChildCp([...newarr])
        errorTost("Please select atleast one Cp and then save")
    } else {
        let newarr = cloneDeep(allChildCp)
        setAllCp([...newarr])
        presentLoader()
        if (allExistingCp.length > 0) {
            let insertarr = differenceWith(arr, allExistingCp, isEqual)
            let deletearr = differenceWith(allExistingCp, arr, isEqual)
            if (insertarr.length > 0) {
                insertarr.forEach((element, index) => {
                  SaveSelectedCp({ projectId: projectId, cpId: element.cpId }).then((resp) => {
                        setAllCp((pre) => { pre[pre.findIndex((e) => e.cpId === element.cpId)].isSelected = true; return [...pre] })
                        if (index === insertarr.length - 1) {
                            if (deletearr.length > 0) {
                                deletearr.forEach((ele, index2) => {
                                  DeleteSelectedCps(ele, projectId).then((res) => {
                                        if (index2 === deletearr.length - 1) {
                                            setAllCp((pre) => { pre[pre.findIndex((e) => e.cpId === element.cpId)].isSelected = false; return [...pre] })
                                          
                                            successTost("Cp Team saved successfully")
                                            setSearchCp('')
                                            dismissLoader()
                                        }
                                    })
                                })
                            } else {
                                
                                successTost("Cp Team saved successfully")
                                setSearchCp('')
                                dismissLoader()
                            }
                        }
                    })
                })
            } else if (deletearr.length > 0) {
                deletearr.forEach((ele, index2) => {
                  DeleteSelectedCps(ele, projectId).then((res) => {
                        if (index2 === deletearr.length - 1) {
                            setAllCp((pre) => { pre[pre.findIndex((e) => e.cpId === ele.cpId)].isSelected = false; return [...pre] }); 
                            
                            successTost("Cp Team saved successfully")
                            setSearchCp('')
                            dismissLoader();
                        }
                    })
                })
            } else {
                successTost("Cp Team saved successfully")
                setSearchCp('')
                dismissLoader();
            }
        } else {
            arr.forEach((ele, index) => {
              SaveSelectedCp({ projectId: projectId, cpId: ele.cpId }).then((resp) => {
                    setAllCp((pre) => { pre[pre.findIndex((e) => e.cpId === ele.cpId)].isSelected = true; return [...pre] });
                    if (index === arr.length - 1) {
                        successTost("Cp Team saved successfully")
                        setSearchCp('')
                        dismissLoader();
                    }
                })
            })
        }
    }

}

function selectAll() {
    setAllChildCp((pre) => {
        pre.forEach((ele, index) => {
            pre[index].isSelected = true;
        })
        return [...pre]
    })
}

function deSelectAll(){
    setAllChildCp((pre) => {
        pre.forEach((ele, index) => {
            pre[index].isSelected = false;
        })
        return [...pre]
    })
}
 

  return (
    <Box className={cssClasses.Container}>
      <Box padding={"2rem"}>
        <Box className={cssClasses.HeaderTitle}>
        {projectName?.projectName}
          </Box>
        <Box className={cssClasses.SubTitle}>
        {projectName?.addressLine1},{projectName?.addressLine2},{projectName?.addressLine3}
        </Box>
      </Box>

      <Divider variant='middle'/>

      <Box overflow={"auto"} height={"100%"}>
      <Box className={cssClasses.FlexRow} marginTop={'2rem'} padding={"0 2.4rem"}>
        <Box className={cssClasses.SubHeaderTitle}>Select Channel Partners</Box>
        {loggedInUser?.roleId?.accessibleTabs?.Sustenance?.CP["CP Save"]?.isAccessible && (
            
            <Box width={'fit-content'} marginLeft={'auto'} mr={2}>
            <Button
              style={{
                color: "#fff",
                backgroundColor: "#1570EF",
                fontSize: "1.4rem",
                lineHeight: "2rem",
                fontFamily: "Roboto-Regular",
              }}
              padding={'0.8rem 2.6rem'}
              // disable={selectedRows.length === 0}
              btnName={'Save'}
              clicked={SaveCp}
            />
          </Box>
        )}
        
      </Box>
      
      <Box className={cssClasses.GridWrapper} padding={"0 2.4rem"}>
             <SelectSalesCp allChildRows={allChildCp} selectAll={selectAll} deSelectAll={deSelectAll} allRows={(allChildCp?.filter((e) => { return e.show === true }))} allColums={cpGridColumns} setSearchSalesCp={setSearchCp} />
        </Box>


      </Box>
    </Box>
  );
}

export default CpSales;